import { EnvironmentTypes } from '@common/constants';
import { RecordRTCLogger } from '../types';

// Default console logger
const defaultLogger: RecordRTCLogger = {
  warn: (message: string, ...args: any[]) => console.warn(message, ...args),
  error: (message: string, error?: any) => console.error(message, error),
  info: (message: string, ...args: any[]) => console.info(message, ...args),
};

// Silent logger for production
const silentLogger: RecordRTCLogger = {
  warn: () => {},
  error: () => {},
  info: () => {},
};

export const createLogger = (
  enableLogging: boolean = true,
  customLogger?: RecordRTCLogger,
): RecordRTCLogger => {
  // Check if we're in local development environment
  const isLocalDev = process.env.NODE_ENV === EnvironmentTypes.DEVELOPMENT;
  if (!enableLogging || !isLocalDev) {
    return silentLogger;
  }

  return customLogger ?? defaultLogger;
};
